import DashboardStatusStatistic from '../../../../../../scheduler/manager/serverless/i-services/models/dashboard/DashboardStatusStatistic';

export default class DashboardParametersResponse  {
	JobsActiveCount!: number;
	JobsExecutesSuccessCount!: number;
	JobsExecutesFailedCount!: number;
	JobExecuteStatusStatistic!: Array<DashboardStatusStatistic>;
	constructor(obj?: Partial<DashboardParametersResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
